import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RUTAS_USER } from "../Rutas";
import LayoutGeneral from "../LayoutGeneral";
import Select from 'react-select';
import "./Usuarios.css";
import 'bootstrap-icons/font/bootstrap-icons.css';

const Usuarios = () => {
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtroEmail, setFiltroEmail] = useState("");
    const [filtroUsuarioActivo, setFiltroUsuarioActivo] = useState("");
    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const cerrarSesion = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("usuario");
        navigate("/");
    };

    // Redireccionamientos
    const GoHome = () => { navigate("/Home"); };
    const GoUsuarios = () => { navigate("/Usuarios"); };
    const GoBitácoras = () => { navigate("/Bitacoras"); };
    const GoNuevoUsuario = () => navigate("/Nuevo_Usuario");
    const GoIncidencias = () => { navigate("/Incidencias"); };

    // Obtener usuarios desde API 
    useEffect(() => {
        const fetchUsuarios = async () => {
            try {
                    const response = await fetch(
                    RUTAS_USER.GET_USERS,
                    {
                        method: "GET",
                        headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                        }
                    }
                );
                if (!response.ok) throw new Error("Error al obtener usuarios");
                const data = await response.json();
                setUsuarios(data);
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchUsuarios();
    }, []);

    const usuariosFiltrados = usuarios.filter(u =>
      (filtroEmail === "" || u.email?.toLowerCase().includes(filtroEmail.toLowerCase())) &&
      (filtroUsuarioActivo === "" || String(u.estatusUsuario) === filtroUsuarioActivo)
    );

  return (
    <LayoutGeneral titulo="Usuarios">
      <div className="home-container">
        <aside className="sidebar">
        <ul>
            <li onClick={GoHome}><i className="bi bi-house"></i> Inicio</li>
            <li onClick={GoUsuarios}><i className="bi bi-people"></i> Usuarios</li>
              <li onClick={GoIncidencias}><i className="bi bi-people"></i> Incidencias</li>
            <li onClick={GoBitácoras}><i className="bi bi-journal"></i> Bitácoras</li>
            <li className="logout" onClick={cerrarSesion}> <i className="bi bi-box-arrow-right"></i> Cerrar Sesión </li>
          </ul>
        </aside>

        {/* Contenido principal */}
        <main className="main-content">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <span className="fw-bold fs-5">Módulo de Usuarios</span>
              <button
                type="button"
                className={`filtro-toggle btn-sm me-2`}
                onClick={() => setMostrarFiltros(!mostrarFiltros)} title="Mostrar/Ocultar filtros" >
                <i className="bi bi-funnel-fill"></i> Filtros
              </button>
            </div>
            <button className="btn btn-primary" onClick={GoNuevoUsuario}>
              <i className="bi bi-plus-lg"></i> Nuevo
            </button>
          </div>

          {mostrarFiltros && (
            <div className="row g-3 mb-4">
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={usuarios.map(u => ({ value: u.email || '', label: `${u.email || ''} — ${u.nombre || ''}` }))}
                  placeholder="Buscar por email o seleccionar..."
                  isClearable
                  onChange={selected => setFiltroEmail(selected ? selected.value : "")}
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: '1rem',
                      minHeight: '46px',
                      boxShadow: 'none',
                      borderColor: '#ced4da'
                    }),
                    menu: (base) => ({
                      ...base,
                      borderRadius: '1rem',
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: '0.75rem',
                      margin: '0.125rem 0',
                      backgroundColor: state.isFocused ? '#e9ecef' : 'white'
                    })
                  }}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Usuario Activo</label>
                <select
                  className="form-select rounded-pill"
                  value={filtroUsuarioActivo}
                  onChange={e => setFiltroUsuarioActivo(e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </div>
            </div>
          )}

          {loading ? (
            <p>Cargando usuarios...</p>
          ) : usuariosFiltrados.length > 0 ? (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th><center>ID Usuario</center></th>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Rol</th>
                  <th>Oficina</th>
                  <th><center>UsuarioActivo</center></th>
                  <th><center>OficinaActiva</center></th>
                  <th><center>EsAdmin</center></th>
                  <th>Editar</th>
                </tr>
              </thead>
              <tbody>
                {usuariosFiltrados.slice().sort((a, b) => a.idUsuario - b.idUsuario).map((u, idx) => (
                  <tr key={idx}>
                    <td><center>{u.idUsuario}</center></td>
                    <td>
                      <span className="usuario-nombre">{u.nombre}</span>
                    </td>
                    <td>{u.email}</td>
                    <td>{u.rol}</td>
                    <td>{u.oficina}</td>
                    <td>
                      <center>
                        <span className={Number(u.estatusUsuario) === 1 ? "estatus-si" : "estatus-no"}>
                          {Number(u.estatusUsuario) === 1 ? "Sí" : "No"}
                        </span>
                      </center>
                    </td>
                    <td>
                      <center>
                        <span className={Number(u.estatusOficina) === 1 ? "estatus-si" : "estatus-no"}>
                          {Number(u.estatusOficina) === 1 ? "Sí" : "No"}
                        </span>
                      </center>
                    </td>
                    <td>
                      <center>
                        <span className={Number(u.admin) === 1 ? "estatus-si" : "estatus-no"}>
                          {Number(u.admin) === 1 ? "Sí" : "No"}
                        </span>
                      </center>
                    </td>
                    <td>
                      <button
                        className="btn btn-primary btn"
                        title="Editar usuario"
                        onClick={() => navigate(`/Actualizar_Usuario/${u.idUsuario}`) }
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No hay usuarios registrados.</p>
          )}
        </main>
      </div>
    </LayoutGeneral>
  );
};

export default Usuarios;
